// Spec: when a participant is DEACTIVATED mid-session the server returns 401 on the
// /api/vdr/* namespace. Detect ONLY that case (401 + participant URL) and send
// the user to the expired/magic-link screen. A 403 is a folder-ACL deny (handled in-page),
// and a 401 on another namespace is unrelated — neither must trigger a logout bounce.

export const EXPIRED_ROUTE = '/data-room/expired'

const VDR_PARTICIPANT_PREFIX = '/api/vdr/'

export function shouldBounceOn401(status: number, url: string): boolean {
  return status === 401 && url.startsWith(VDR_PARTICIPANT_PREFIX)
}
